import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { RootState } from '../../redux/reducers/reducers';
import { useNavigate } from 'react-router-dom';


import {
    Button,
    Grid,
    useTheme,
    Dialog,
    Box,
    Typography,
    Stack,
    FormHelperText,
    Checkbox,
    FormControlLabel,
    OutlinedInput,
    InputLabel,
    InputAdornment,
    IconButton,
    Link
} from '@mui/material'
import { Link as RouterLink } from 'react-router-dom';
import { Formik, FormikHelpers, FormikState } from 'formik';
import * as Yup from 'yup';
import { RemoveRedEyeOutlined, VisibilityOffOutlined } from '@mui/icons-material';
import { forgotPasswordRequest, changePassword } from '../../config/config'

import actions from '../../redux/actions/auth.actions'


interface Props {
}

interface Fields {
    email: string;
}

interface Fields2 {
    code: string;
    password: string;
    confirmPass: string;
}
const ForgotPassword: React.FC<Props> = ({

}) => {
    const [checked, setChecked] = React.useState(false);
    const navigate = useNavigate()
    const [step, setStep] = useState(1)
    const [fpRequest, setforgotPasswordRequest] = useState({
        token: '',
        loading: false,
        error: ''
    })

    const [cpRequest, setChangePasswordRequest] = useState({
        loading: false,
        error: ''
    })

    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event: any) => {
        event.preventDefault();
    };

    const initialValues: Fields = {
        email: '',
    }

    const initialValues2: Fields2 = {
        code: '',
        password: '',
        confirmPass: ''
    }

    const validationSchema = Yup.object().shape({
        email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
    })

    const validationSchema2 = Yup.object().shape({
        code: Yup.string().required('code is required'),
        password: Yup.string()
        .max(255)
        .required('Password is required')
        .test(
          'password-pattern',
          'Password must have at least 1 special character, 1 letter, 1 number, and be at least 8 characters long.',
          (value) => {
            return /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/.test(value);
          }
        ),
        confirmPass: Yup.string()
            .oneOf([Yup.ref('password'), ''], 'Passwords must match')
            .max(255)
            .required('Password confirmation is required'),
    })

    const handleSubmit = async (values: FormikState<Fields>['values']) => {
        setforgotPasswordRequest({ ...fpRequest, loading: true, error: '', token: '' })
        const response = await forgotPasswordRequest(values)
        if (response.status === 200) {
            setStep(2)
            setforgotPasswordRequest({ ...fpRequest, loading: false, error: '', token: response.data.token })
        } else {
            setforgotPasswordRequest({ ...fpRequest, loading: false, error: response?.message || 'Something went wrong', token: '' })
        }
    }

    const handleSubmit2 = async (values: FormikState<Fields2>['values']) => {
        setChangePasswordRequest({...cpRequest, loading:true , error:''})
        const response = await changePassword({
            ...values, token: fpRequest.token
        })
        if (response.status === 200) {
            setChangePasswordRequest({...cpRequest, loading:false , error:''})
            navigate('/auth/login')
        } else {
            setChangePasswordRequest({...cpRequest, loading:false , error: response?.message || 'Something went wrong'})
        }
    }
    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
                    <Typography variant="h3">Forgot Password</Typography>
                    <Typography variant="body1" sx={{ textDecoration: 'none' }} color="primary">
                    </Typography>
                </Stack>
            </Grid>

            {step === 1 && <Grid item xs={12}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                        <form noValidate onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Stack spacing={1}>
                                        <InputLabel htmlFor="email-login">Email Address</InputLabel>
                                        <OutlinedInput
                                            id="email-login"
                                            type="email"
                                            value={values.email}
                                            name="email"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            placeholder="Enter email address"
                                            fullWidth
                                            error={Boolean(touched.email && errors.email)}
                                        />
                                        {touched.email && errors.email && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.email}
                                            </FormHelperText>
                                        )}
                                    </Stack>
                                </Grid>

                                <Grid item xs={12} sx={{ mt: -1 }}>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                                        <Link variant="h6" component={RouterLink} to="/auth/login" color="text.primary">
                                            Already have an account?
                                        </Link>
                                    </Stack>
                                </Grid>
                                {fpRequest.error && (
                                    <Grid item xs={12}>
                                        <FormHelperText error>{fpRequest.error}</FormHelperText>
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <Button disableElevation disabled={fpRequest.loading} fullWidth size="large" type="submit" variant="contained" color="primary">
                                        Send Code
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </Grid>
            }

            {step === 2 && <Grid item xs={12}>
                <Formik
                    initialValues={initialValues2}
                    validationSchema={validationSchema2}
                    onSubmit={handleSubmit2}
                >
                    {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                        <form noValidate onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Stack spacing={1}>
                                        <InputLabel htmlFor="code-login">OTP</InputLabel>
                                        <OutlinedInput
                                            id="code-login"
                                            type="text"
                                            value={values.code}
                                            name="code"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            placeholder="Enter code"
                                            fullWidth
                                            error={Boolean(touched.code && errors.code)}
                                        />
                                        {touched.code && errors.code && (
                                            <FormHelperText error id="standard-weight-helper-text-code-login">
                                                {errors.code}
                                            </FormHelperText>
                                        )}
                                    </Stack>
                                </Grid>

                                <Grid item xs={12}>
                                    <Stack spacing={1}>
                                        <InputLabel htmlFor="password-login">Password</InputLabel>
                                        <OutlinedInput
                                            fullWidth
                                            error={Boolean(touched.password && errors.password)}
                                            id="-password-login"
                                            type={showPassword ? 'text' : 'password'}
                                            value={values.password}
                                            name="password"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        {showPassword ? <RemoveRedEyeOutlined /> : <VisibilityOffOutlined />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            placeholder="Enter new password"
                                        />
                                        {touched.password && errors.password && (
                                            <FormHelperText error id="standard-weight-helper-text-password-login">
                                                {errors.password}
                                            </FormHelperText>
                                        )}
                                    </Stack>
                                </Grid>

                                <Grid item xs={12}>
                                    <Stack spacing={1}>
                                        <InputLabel htmlFor="password-login">Confirm Password</InputLabel>
                                        <OutlinedInput
                                            fullWidth
                                            error={Boolean(touched.confirmPass && errors.confirmPass)}
                                            id="-confirmPass-login"
                                            type={showPassword ? 'text' : 'password'}
                                            value={values.confirmPass}
                                            name="confirmPass"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        {showPassword ? <RemoveRedEyeOutlined /> : <VisibilityOffOutlined />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            placeholder="Confirm new password"
                                        />
                                        {touched.confirmPass && errors.confirmPass && (
                                            <FormHelperText error id="standard-weight-helper-text-confirmPass-login">
                                                {errors.confirmPass}
                                            </FormHelperText>
                                        )}
                                    </Stack>
                                </Grid>

                                <Grid item xs={12} sx={{ mt: -1 }}>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                                        <Link variant="h6" component={RouterLink} to="/auth/login" color="text.primary">
                                            Already have an account?
                                        </Link>
                                    </Stack>
                                </Grid>
                                {cpRequest.error && (
                                    <Grid item xs={12}>
                                        <FormHelperText error>{cpRequest.error}</FormHelperText>
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <Button disableElevation disabled={cpRequest.loading} fullWidth size="large" type="submit" variant="contained" color="primary">
                                        Change password
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </Grid>
            }
        </Grid>
    )
}

export default ForgotPassword;
// const mapStateToProps = (state: RootState) => ({
//     error: state.auth.error ,
//     token: state.auth.token,
//     loading: state.auth.loading

// });

// const mapDispatchToProps = (dispatch: any) => ({
//     login: (data: any) => dispatch(actions.signIn(data))
// });

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(ForgotPassword);